import { useChartDimensions } from '../utils/dimensions'
import Chart from './Chart/Chart'
import Jobs from './Chart/Jobs/Jobs'
import Opportunity from './Chart/Opportunity/Opportunity'
import Wages from './Chart/Wages/Wages'
import ProgressIndicator from './ProgressIndicator'

const Stage = ({ currentStepIndex, direction, chart, fade }) => {
  const [ref, dimensions] = useChartDimensions({
    marginTop: 16,
    marginRight: 40,
    marginBottom: 60,
    marginLeft: 54
  })
  const chartContent = {
    jobs: <Jobs step={currentStepIndex} direction={direction} chart={chart} />,
    opportunity: (
      <Opportunity
        step={currentStepIndex}
        direction={direction}
        fade={fade}
        chart={chart}
      />
    ),
    wage: (
      <Wages
        step={currentStepIndex}
        direction={direction}
        fade={fade}
        chart={chart}
      />
    )
  }

  const chartTitle = {
    jobs: 'Jobs: New firms generate the bulk of net job growth',
    opportunity:
      'Opportunity: A dynamic economy creates job opportunities for marginalized workers',
    wage: 'Wages: Dynamic labor markets accelerate wage growth'
  }

  const chartDataSource = {
    jobs: 'Source: U.S. Census Bureau’s Business Dynamics Statistics',
    opportunity: '',
    wage: 'Source: Federal Reserve Bank of Atlanta’s Wage Growth Tracker'
  }

  //const isSmall = window.innerWidth < 769
  return (
    <>
      <div
        className={`scrolly-headline step-${currentStepIndex} ${
          fade ? 'fade-out' : ''
        }`}
      >
        {chartTitle[chart]}
      </div>
      <div className="stage">
        <div className="sidebar-placeholder">
          <ProgressIndicator chart={chart} step={currentStepIndex} />
        </div>
        <div className="figure-chart" ref={ref}>
          <Chart
            dimensions={dimensions}
            step={currentStepIndex}
            direction={direction}
          >
            {chartContent[chart]}
          </Chart>

          {/* {isSmall && (
            <ProgressIndicator chart={chart} step={currentStepIndex} />
          )} */}

          <div className="foot-note">{chartDataSource[chart]}</div>
        </div>
      </div>
    </>
  )
}

export default Stage
